import { useEffect } from "react";
import { NavLink, Outlet } from "react-router";

import InfoIconTooltip from "components/tooltip/InfoIconTooltip";
import { SideMenu } from "components/menu/SideMenu/SideMenu";
import { LinkPrimaryArrow } from "components/link/Link";
import { captureEvent } from "components/posthog/customEventCapture";
import { useGlobalContext } from "app/store/GlobalContext";
import { useRootStore } from "store";

export default function DocumentDelivery() {
  const { global, user, archive } = useRootStore((state) => state);
  const { fetchUploadedFiles } = useRootStore((state) => state.delivery);
  const { handleNavigation } = useGlobalContext();

  const {fetchArchiveFolders} = archive

  useEffect(() => {
    if (global.workingCustomerId) {
      fetchArchiveFolders(global.workingCustomerId);
      fetchUploadedFiles(global.workingCustomerId);
    }
  }, [global.workingCustomerId, fetchUploadedFiles, fetchArchiveFolders]);

  const isInternalUser = user.userInfo && user.userInfo.type === "Internal";

  return (
    <div
      data-testid="document-delivery"
      className="flex-column-md-down d-flex flex-wrap align-items-start"
    >
      <SideMenu
        title={
          <span className="d-flex align-items-center justify-content-between">
            Inleveranser
            {isInternalUser && (
              <InfoIconTooltip className="ml-3">
                <h3>Nya inleveranser</h3>
                <p>
                  Här hittar du de inleveranser som kunden har laddat upp i
                  MittKontor och som ännu inte har blivit hanterade. Om du vill
                  spara filen i Dokumentarkivet, välj Flytta och välj vilken
                  mapp du vill spara filen i. När filen är sparad bland mapparna
                  flyttas filen automatiskt till Hanterade. Om du väljer att
                  använda filen på annat sätt än att spara den bland mapparna,
                  klicka på Hantera när du är klar med filen
                </p>

                <h3>Hanterade</h3>
                <p>
                  När du eller någon annan i kundteamet har klickat på Hantera
                  hamnar filen automatiskt under Hanterade. Här sparas alla
                  hanterade filer. Om du vill spara en fil i Dokumentarkivet
                  klickar du på Flytta och flyttar filen till önskad mapp. Du
                  kan inte ta bort filer från Hanterade.
                </p>
              </InfoIconTooltip>
            )}
          </span>
        }
      >
        <div className="d-flex flex-wrap">
          <div className="d-flex flex-direction-column align-items-start mr-relative">
            {!isInternalUser && (
              <LinkPrimaryArrow
                className="my-4"
                to={"/delivery"}
                onClick={(e) => {
                  e.preventDefault();
                  handleNavigation({
                    url: "/delivery",
                    eventTitle: "Ladda upp",
                    e: e,
                  });
                }}
              >
                Ladda upp
              </LinkPrimaryArrow>
            )}

            {!isInternalUser && (
              <NavLink
                className={`side-menu-link`}
                to={"/delivery/uploaded"}
                onClick={(e) =>
                  handleNavigation({
                    url: "/delivery/uploaded",
                    eventTitle: "Uppladdade filer",
                    e: e,
                  })
                }
              >
                Uppladdade filer
              </NavLink>
            )}

            {isInternalUser && (
              <NavLink
                className={`side-menu-link`}
                to={"/delivery/new"}
                onClick={() => captureEvent("Nya leveranser")}
              >
                Nya leveranser
              </NavLink>
            )}

            {isInternalUser && (
              <NavLink
                className={`side-menu-link`}
                to={"/delivery/handled"}
                onClick={() => captureEvent("Hanterade")}
              >
                Hanterade
              </NavLink>
            )}
          </div>
        </div>
      </SideMenu>

      <div className="box flex-1-1 overflow-y-auto w-100">
        <Outlet />
      </div>
    </div>
  );
}
